import { ApplicationState, AppThunkDispatch } from "../../store";
import { connect } from "react-redux";
import StockItemForm from "../../components/Forms/StockItemForm";
import { StockEntity } from "../../store/entities/state";
import { getChangingState, getChangingValue, isSubmittingNew } from "../../store/entities/selectors";
import { createEntity, entityCreatingCancel, updateChangingEntity } from "../../store/entities/actions";
import { createStockAsync } from "../../ajax/requests";
import { StockItemFormDispatchProps, StockItemFormStateProps } from "../../components/Forms/StockItemForm/StockItemForm";

const mapStateToProps = (state: ApplicationState): StockItemFormStateProps => ({
    type: 'create',
    canEdit: true,
    data: getChangingValue(state, 'stock') as StockEntity,
    hasChanged: getChangingState(state, 'stock'),
    isSubmitting: isSubmittingNew(state, 'stock'),
})

const mapDispatchToProps = (dispatch: AppThunkDispatch): StockItemFormDispatchProps => ({
    onChange: (data: StockEntity) => dispatch(updateChangingEntity('stock', data)),
    onCancel: () => dispatch(entityCreatingCancel('stock')),
    onSave: (data: StockEntity) => dispatch(createEntity('stock', data, s => createStockAsync(s))),
});

export default connect<StockItemFormStateProps, StockItemFormDispatchProps, unknown, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(StockItemForm as any);
